import { Box, Button, Dialog, DialogActions, DialogTitle } from '@mui/material';
import PropTypes from 'prop-types';

export default function RestoreDialog({ openRestore, setOpenRestore, nameToBeRestored, nameType, handleRestoreOk }) {
  return (
    <Dialog open={openRestore} onClose={() => setOpenRestore(false)}>
      <Box sx={{ backgroundColor: (theme) => theme.palette.mode === 'light' ? '#F9F9FB' : '#272424' }}>
        <DialogTitle>
          እርግጠኛ ንዎት {nameToBeRestored} {nameType}ን መመለስ ይፈልጋሉ?
        </DialogTitle>
        <DialogActions>
          <Button color="error" onClick={() => setOpenRestore(false)}>
            ተመለስ
          </Button>
          <Button color="success" variant="contained" onClick={handleRestoreOk} autoFocus>
            ኦዎ መልስ
          </Button>
        </DialogActions>
        </Box>
    </Dialog>
  );
}

RestoreDialog.propTypes = {
  openRestore: PropTypes.bool.isRequired,
  setOpenRestore: PropTypes.func.isRequired,
  nameToBeRestored: PropTypes.string.isRequired,
  nameType: PropTypes.string.isRequired,
  handleRestoreOk: PropTypes.func.isRequired,
};
